import * as React from 'react';
import React__default, { createContext, useContext } from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import { Theme, light, typography, spacing } from '@rocker-ui/core';
import Button$1 from '@mui/material/Button';
import MuiStepper from '@mui/material/Stepper';
import StepConnector from '@mui/material/StepConnector';
import MuiStepButton from '@mui/material/StepButton';
export { default as Step } from '@mui/material/Step';
import Modal from '@mui/material/Modal';
import { keyframes, css } from '@emotion/react';
import styled from '@emotion/styled';
import MUIRadio from '@mui/material/Radio';
import CircularProgress from '@mui/material/CircularProgress';
import { ListItemButton, Drawer as Drawer$1, List, Toolbar, MenuItem } from '@mui/material';
import { styled as styled$1 } from '@mui/material/styles';
import MuiTextField from '@mui/material/TextField';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Checkbox = function (props) { return (React__default.createElement(MuiCheckbox, __assign({}, props, { disableRipple: true }))); };

var Context = createContext(undefined);
var useThemeContext = function () {
    var themeContext = useContext(Context);
    if (themeContext === undefined) {
        throw new Error('useThemeContext must be used within a ThemeProvider');
    }
    return themeContext;
};
var ThemeProvider = function (_a) {
    var children = _a.children, value = _a.value;
    if (value === undefined) {
        throw new Error('theme value must be provided within a ThemeProvider');
    }
    return React__default.createElement(Context.Provider, { value: value }, children);
};

var Light$1 = Theme.ColorScheme.Light;
// eslint-disable-next-line new-cap
var Default = Theme.FontFamily.Default('web');
var muiTheme = {
    typography: {
        fontFamily: Default.regular,
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                contained: {
                    '&:active': { boxShadow: '' },
                    '&:hover': { boxShadow: '' },
                    boxShadow: '',
                    padding: '12px 16px',
                },
                containedPrimary: {
                    '&:active': { backgroundColor: Light$1.button.main.active },
                    '&:hover': { backgroundColor: Light$1.button.main.hover },
                    '&:disabled': {
                        color: Light$1.button.main.text,
                        backgroundColor: Light$1.button.main.disabled,
                    },
                    backgroundColor: Light$1.button.main.BG,
                },
                textPrimary: {
                    '&:active': { backgroundColor: 'rgba(98, 53, 255, 0.16)' },
                    '&:hover': { backgroundColor: 'rgba(98, 53, 255, 0.04)' },
                    color: Light$1.button.secondary.outlined.text,
                },
                outlinedPrimary: {
                    '&:active': {
                        backgroundColor: 'rgba(98, 53, 255, 0.24)',
                        borderColor: Light$1.button.main.BG,
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(98, 53, 255, 0.08)',
                        borderColor: Light$1.button.main.BG,
                    },
                    '&:disabled': {
                        color: Light$1.button.secondary.outlined.disabled,
                        borderColor: Light$1.button.secondary.outlined.disabled,
                    },
                    color: Light$1.button.main.BG,
                    borderColor: Light$1.button.main.BG,
                },
                root: {
                    '&:hover': { backgroundColor: 'rgba(98, 53, 255, 0.04)' },
                    '&:active': {
                        backgroundColor: 'rgba(98, 53, 255, 0.16)',
                    },
                    borderRadius: '24px',
                    boxShadow: '',
                    fontFamily: Default.bold,
                    fontSize: '1rem',
                    lineHeight: '24px',
                    padding: '12px 16px',
                    textTransform: 'none',
                },
                outlined: { fontFamily: Default.regular, padding: '12px 16px' },
                startIcon: { marginRight: '16px' },
                sizeSmall: {
                    padding: '8px 16px',
                    lineHeight: '18px',
                    fontSize: '13px',
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: { color: Light$1.form.checkbox.color },
                colorSecondary: {
                    '&:hover': { backgroundColor: 'transparent' },
                    '&.Mui-checked': {
                        '&:hover': { backgroundColor: 'transparent !important' },
                        color: Light$1.form.checkbox.checkedColor,
                    },
                    '&.Mui-disabled': { color: Light$1.form.checkbox.disabled },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontFamily: Default.regular,
                    color: Light$1.text.sub3,
                    fontSize: '14px',
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: { fontFamily: Default.regular },
            },
        },
    },
};
var pay2Theme = {
    spacing: {
        xsmall: '4px',
        small: '8px',
        medium: '16px',
        large: '24px',
        xlarge: '28px',
        xxlarge: '32px',
        xxxlarge: '48px',
    },
    contentWidth: { large: '1080px', small: '600px' },
    headerHeight: '110px',
    breakpoint: {
        xlarge: '1200px',
        large: '900px',
        medium: '800px',
        small: '650px',
    },
};

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};

// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType
  } : {};
  fn.filterProps = [prop];
  return fn;
}

const boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});

var theme2022 = __assign({ rockerColors: light, rockerTypography: typography, rockerSpacing: spacing }, { shadows: Array(boxShadow.length).fill("none"), spacing: function (factor) { return "".concat(4 * factor, "px"); }, palette: {
        getContrastText: function () { return "white"; },
        primary: {
            main: light.brand,
        },
        secondary: {
            main: "#FFF",
        },
        info: {
            main: light.icons,
        },
        background: {
            default: light.backgroundPrimary,
            paper: light.surfacePrimary,
        },
        warning: {
            main: light.error,
        },
        success: {
            main: light.success,
        },
        text: {
            primary: light.onBackgroundPrimary,
            secondary: light.onBackgroundSecondary,
            disabled: light.loading,
        },
        divider: light.border,
        error: {
            main: light.error,
        },
    }, typography: {
        button: __assign({}, typography.BUTTON_PRIMARY),
        allVariants: __assign({}, typography.BODY_2),
        h1: __assign({}, typography.HEADING_1),
        h2: __assign({}, typography.HEADING_2),
        h4: __assign({}, typography.HEADING_4),
        h5: __assign({}, typography.HEADING_5),
        h6: __assign({}, typography.HEADING_5_BOLD),
    }, components: {
        MuiCheckbox: {
            styleOverrides: {
                root: "\n            &:hover {\n              background: none;\n            }\n            &.Mui-checked {\n              &:hover {\n                background: none;\n              }\n              color: ".concat(light.brand, ";\n            }\n          "),
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "24px",
                    padding: "12px 28px",
                    flexGrow: 0,
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: "\n          background-color: ".concat(light.surfacePrimary, ";\n          &:hover {\n            background-color: ").concat("#ECECFF", ";\n            &:before {\n              border-bottom: ").concat("3px solid ".concat(light.brand, " !important"), ";\n            }\n            &:after {\n              && {\n                border-bottom: ").concat("3px solid ".concat(light.brand, " !important"), ";\n              }\n            }\n          }\n          &:before {\n            border-bottom: ").concat("3px solid ".concat("#BBB7D1"), ";\n          }\n          &:after {\n            border-bottom: ").concat("3px solid ".concat(light.brand), ";\n          }\n  \n          &.Mui-error {\n            &:after,\n            &:before {\n              border-color: ").concat(light.error, ";\n          }\n  \n          &.Mui-disabled {\n            background-color: ").concat("#F5F5F8", ";\n            &:hover {\n              background-color: ").concat("#F5F5F8", ";\n            }\n            &:before,\n            &:after {\n            border-bottom: ").concat("3px solid ".concat("#BBB7D1", " !important"), ";\n          }\n        "),
                input: "\n          border-radius: 4px;\n          color: ".concat(light.brand, ";\n          font-family: ").concat(typography.INPUT_TEXT, ";\n          &:hover {\n            color: ").concat(light.brand, ";\n          }\n          &:focus {\n            background-color: ").concat("#ECECFF", ";\n            color: ").concat(light.brand, ";\n          }\n          "),
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: "\n          \"&.Mui-error\": {\n            color: light.error,\n          }\n          ",
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    zIndex: 9999,
                    backgroundColor: "primary",
                    position: "fixed",
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: "transparent",
                },
                flexContainer: {
                    background: "#F2F3F7",
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        opacity: 0.5,
                    },
                    textTransform: "capitalize",
                    color: "#595388",
                    background: "#DBDDF0",
                    borderRadius: "16px 16px 0px 0px",
                    "&.Mui-selected": {
                        fontWeight: "bold",
                        color: light.brand,
                        background: light.surfacePrimary,
                    },
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    borderRight: "none",
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: "#8C8DBA",
                    fontWeight: 500,
                    borderBottom: "2px solid transparent",
                    "&.Mui-selected": {
                        backgroundColor: "#F2F3F7",
                        color: light.brand,
                        borderBottom: "2px solid ".concat(light.brand),
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    borderRadius: "16px",
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: light.interactiveMain,
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                panelWrapper: {
                    background: "#F2F3F7",
                    boxShadow: "rgb(100 100 111 / 20%) 0px 7px 29px 0px",
                },
                menu: {
                    boxShadow: "rgb(100 100 111 / 20%) 0px 7px 29px 0px",
                },
                columnHeader: __assign({}, typography.HEADING_4_BOLD),
                panelContent: {
                    backgroundColor: "#F2F3F7",
                },
                root: {
                    background: "#F2F3F7",
                    color: "#000",
                    borderRadius: "16px",
                    border: "none",
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: "16px",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    ":last-child": {
                        paddingBottom: "16px",
                    },
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: "\n        @font-face {\n          font-family: \"AeonikPro-Bold\";\n          font-style: normal;\n          font-weight: 100 900;\n          font-display: swap;\n          src: url(/fonts/AeonikPro-Bold.otf) format(\"woff\");\n          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;\n        }\n        \n        @font-face {\n          font-family: \"AeonikPro-Medium\";\n          font-style: normal;\n          font-weight: 100 900;\n          font-display: swap;\n          src: url(/fonts/AeonikPro-Medium.otf) format(\"woff\");\n          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF; \n        }\n        \n        @font-face {\n          font-family: \"Aeonik-Regular\";\n          font-style: normal;\n          font-weight: 100 900;\n          font-display: swap;\n          src: url(/fonts/Aeonik-Regular.otf) format(\"woff\");\n          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;\n  \n        \n        }\n        \n        html,\n        body {\n          padding: 0;\n          margin: 0;\n          font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n            Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n        }\n  \n        a {\n          color: inherit;\n          text-decoration: none;\n        }\n  \n        * {\n          box-sizing: border-box;\n        }\n        \n        ",
        },
    } });

var Swish$1 = function (_a) {
    var color = _a.color, size = _a.size;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 28 27", fill: "none" },
        React.createElement("path", { d: "M8.17135 25.6602C13.5899 28.2517 20.2771 26.9692 24.3171 22.1555C29.1056 16.45 28.3619 7.94423 22.6559 3.15735L18.8627 7.67705C23.3204 11.4168 23.9015 18.0619 20.1605 22.5193C17.1776 26.0735 12.2663 27.2602 8.17135 25.6602Z", fill: color }),
        React.createElement("path", { d: "M19.8021 1.31329C14.3836 -1.27819 7.69636 0.00430085 3.65637 4.81799C-1.13212 10.5235 -0.388364 19.0293 5.31757 23.8161L9.11082 19.2964C4.65305 15.5567 4.07201 8.91159 7.813 4.45414C10.7959 0.899963 15.7072 -0.286746 19.8021 1.31329Z", fill: color })));
};

var BankID$1 = function (_a) {
    var color = _a.color, size = _a.size;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 42 41", fill: "none" },
        React.createElement("path", { d: "M13.1676 21.1079L14.9109 9.85042C14.2242 9.85042 13.0488 9.85042 13.0488 9.85042C12.1771 9.85042 11.0545 9.34979 10.7243 8.42971C10.6187 8.1185 10.3677 7.04958 11.8073 6.00772C12.3224 5.64239 12.6526 5.23647 12.7186 4.92527C12.7846 4.60053 12.7054 4.31639 12.4809 4.0999C12.1639 3.78869 11.5432 3.61279 10.7507 3.61279C9.41684 3.61279 8.47915 4.39757 8.3867 4.96586C8.32066 5.38531 8.63763 5.72358 8.91498 5.94007C9.74702 6.57601 9.94512 7.49609 9.43005 8.36205C8.90177 9.25508 7.75276 9.83689 6.52451 9.85042C6.52451 9.85042 5.30947 9.85042 4.62271 9.85042C4.46422 10.9464 1.87566 27.7515 1.67755 29.0775H11.9922C12.0847 28.4821 12.5601 25.3024 13.2072 21.1079H13.1676Z", fill: color }),
        React.createElement("path", { d: "M26.9816 0H16.482L15.0821 9.10613H16.865C17.8424 9.10613 18.7668 8.64609 19.163 7.98309C19.2951 7.7666 19.3479 7.57717 19.3479 7.40127C19.3479 7.02241 19.097 6.73827 18.8461 6.54884C18.1593 6.02114 18.014 5.46638 18.014 5.074C18.014 4.99281 18.014 4.92516 18.0272 4.85751C18.1725 3.89683 19.4404 2.85497 21.1177 2.85497C22.1214 2.85497 22.8874 3.09852 23.3497 3.54503C23.7591 3.93742 23.9176 4.49218 23.7987 5.074C23.6534 5.76406 22.9799 6.33235 22.5969 6.61649C21.5799 7.34715 21.712 7.98309 21.778 8.17252C21.9893 8.7408 22.795 9.10613 23.4157 9.10613H26.1231C26.1231 9.10613 26.1231 9.10613 26.1231 9.11966C29.8211 9.14672 31.8021 10.8922 31.1814 14.9514C30.6003 18.7264 27.774 20.3501 24.4062 20.3772L23.0723 29.0909H25.0402C33.3473 29.0909 40.1357 23.6245 41.4696 14.992C43.1205 4.27569 36.4906 0 26.9816 0Z", fill: color }),
        React.createElement("path", { d: "M26.9816 0H16.482L15.0821 9.10613H16.865C17.8424 9.10613 18.7668 8.64609 19.163 7.98309C19.2951 7.7666 19.3479 7.57717 19.3479 7.40127C19.3479 7.02241 19.097 6.73827 18.8461 6.54884C18.1593 6.02114 18.014 5.46638 18.014 5.074C18.014 4.99281 18.014 4.92516 18.0272 4.85751C18.1725 3.89683 19.4404 2.85497 21.1177 2.85497C22.1214 2.85497 22.8874 3.09852 23.3497 3.54503C23.7591 3.93742 23.9176 4.49218 23.7987 5.074C23.6534 5.76406 22.9799 6.33235 22.5969 6.61649C21.5799 7.34715 21.712 7.98309 21.778 8.17252C21.9893 8.7408 22.795 9.10613 23.4157 9.10613H26.1231C26.1231 9.10613 26.1231 9.10613 26.1231 9.11966C29.8211 9.14672 31.8021 10.8922 31.1814 14.9514C30.6003 18.7264 27.774 20.3501 24.4062 20.3772L23.0723 29.0909H25.0402C33.3473 29.0909 40.1357 23.6245 41.4696 14.992C43.1205 4.27569 36.4906 0 26.9816 0Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.12259 32.9604H5.33562C7.13177 32.9604 7.5676 33.8941 7.43553 34.7465C7.32987 35.4366 6.86763 35.9507 6.07521 36.289C7.07894 36.6814 7.47515 37.2903 7.32987 38.2509C7.14497 39.4552 6.12804 40.3482 4.79413 40.3482H0L1.12259 32.9604ZM3.90873 36.0186C4.72757 36.0186 5.11057 35.5721 5.18981 35.0444C5.26905 34.4761 5.01812 34.0837 4.19929 34.0837H3.4729L3.18235 36.0186H3.90873ZM4.91337 38.1432C4.79451 38.8603 4.30585 39.2121 3.46061 39.2121V39.2256H2.6946L3.01157 37.1555H3.84361C4.66244 37.1555 5.00582 37.5208 4.91337 38.1432Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.3448 39.8751C11.6089 40.3622 12.1372 40.484 13.2334 40.4028L13.8673 38.8874C13.2466 38.8739 13.2202 38.698 13.3126 38.1297L13.5636 36.506C13.7749 35.0717 12.6391 34.5305 11.358 34.5305C10.3543 34.5305 9.4826 34.8417 8.58452 35.5047L8.33359 37.1825C9.37694 36.4519 9.98446 36.2083 10.7108 36.2083C11.3316 36.2083 11.5297 36.3977 11.4768 36.9119C11.1795 37.1191 10.6732 37.2494 10.1437 37.3857C9.49747 37.5521 8.81673 37.7273 8.43924 38.062C8.12228 38.3462 7.92417 38.6844 7.87134 39.0362C7.75248 39.7669 8.18831 40.4299 9.42977 40.4299C10.1165 40.4299 10.7637 40.2405 11.3448 39.8751ZM10.6145 38.1441C10.873 38.0667 11.1317 37.9892 11.3313 37.8591L11.2124 38.671C11.1728 38.928 11.1596 39.0634 11.186 39.1987C10.8426 39.4422 10.42 39.591 10.0766 39.591C9.72003 39.591 9.49552 39.3204 9.54834 38.9551C9.62639 38.4398 10.1201 38.292 10.6145 38.1441Z", fill: color }),
        React.createElement("path", { d: "M15.2812 34.6252H17.4736L17.3547 35.3694C18.0547 34.7605 18.583 34.5305 19.2697 34.5305C20.498 34.5305 21.0659 35.3018 20.8678 36.5601L20.2999 40.3352H18.1075L18.583 37.2096C18.6754 36.6413 18.5037 36.3707 18.0811 36.3707C17.7377 36.3707 17.4207 36.5601 17.117 36.9796L16.6151 40.3216H14.4228L15.2812 34.6252Z", fill: color }),
        React.createElement("path", { d: "M22.5711 32.9604H24.7635L24.2088 36.5867L26.3087 34.6247H29.0161L26.3219 37.0602L28.4879 40.3347H25.7276L24.0635 37.6962H24.0371L23.6409 40.3347H21.4485L22.5711 32.9604Z", fill: color }),
        React.createElement("path", { d: "M30.3367 32.9604H32.8592L31.7498 40.3347H29.2273L30.3367 32.9604Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.6923 32.9604H34.0868L32.9642 40.3347H37.0319C39.4752 40.3347 40.7695 38.4268 41.0204 36.749C41.2846 35.0306 40.4789 32.9604 37.6923 32.9604ZM38.5244 36.6414C38.3263 37.9539 37.6528 38.5763 36.4245 38.5763H35.7642L36.3453 34.7065H37.0188C38.3791 34.7065 38.6697 35.6672 38.5244 36.6414Z", fill: color })));
};

var Close = function (_a) {
    var color = _a.color, size = _a.size;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 18 18", fill: "none" },
        React.createElement("path", { d: "M0.292893 1.70711L16.2929 17.7071L17.7071 16.2929L1.70711 0.292893L0.292893 1.70711ZM16.2929 0.292893L0.292893 16.2929L1.70711 17.7071L17.7071 1.70711L16.2929 0.292893Z", fill: color })));
};

var Swish = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 163 : _b, color = _a.color;
    return (React.createElement("svg", { width: size, height: size * 0.3, viewBox: "0 0 578 176" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { x1: "80.8150544%", y1: "59.6365716%", x2: "59.8678229%", y2: "8.14952521%", id: "linearGradient-1" },
                React.createElement("stop", { stopColor: "#EF2131", offset: "0%" }),
                React.createElement("stop", { stopColor: "#FECF2C", offset: "100%" })),
            React.createElement("linearGradient", { x1: "58.8181173%", y1: "0%", x2: "9.24395007%", y2: "94.0712606%", id: "linearGradient-2" },
                React.createElement("stop", { stopColor: "#FBC52C", offset: "0%" }),
                React.createElement("stop", { stopColor: "#F87130", offset: "26.3921199%" }),
                React.createElement("stop", { stopColor: "#EF52E2", offset: "56.079734%" }),
                React.createElement("stop", { stopColor: "#661EEC", offset: "100%" })),
            React.createElement("linearGradient", { x1: "20.5690473%", y1: "41.0176198%", x2: "40.5972643%", y2: "91.2765373%", id: "linearGradient-3" },
                React.createElement("stop", { stopColor: "#78F6D8", offset: "0%" }),
                React.createElement("stop", { stopColor: "#77D1F6", offset: "26.5705044%" }),
                React.createElement("stop", { stopColor: "#70A4F3", offset: "55.447147%" }),
                React.createElement("stop", { stopColor: "#661EEC", offset: "100%" })),
            React.createElement("linearGradient", { x1: "42.4403836%", y1: "100%", x2: "91.6136906%", y2: "6.27757791%", id: "linearGradient-4" },
                React.createElement("stop", { stopColor: "#536EED", offset: "0%" }),
                React.createElement("stop", { stopColor: "#54C3EC", offset: "24.6657524%" }),
                React.createElement("stop", { stopColor: "#64D769", offset: "56.4199509%" }),
                React.createElement("stop", { stopColor: "#FECF2C", offset: "100%" }))),
        React.createElement("g", { id: "02-Secondary-(Horizontal)/Colour/Light-background/Swish_Logo_Secondary_Light-BG", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Wordmark/Swish", transform: "translate(222.000000, 33.000000)", fill: color || '#4A4A49', fillRule: "nonzero" },
                React.createElement("path", { d: "M327.058556,15.9033093 C327.058556,13.8736577 327.431906,11.9708878 328.178619,10.1949426 C328.925332,8.41899743 329.938713,6.87007599 331.218792,5.54813183 C332.498871,4.22618767 333.998941,3.18467154 335.719047,2.42355217 C337.439153,1.66243281 339.285906,1.28187884 341.259361,1.28187884 C343.259485,1.28187884 345.132906,1.66243281 346.87968,2.42355217 C348.626455,3.18467154 350.146526,4.22618767 351.439939,5.54813183 C352.733352,6.87007599 353.7534,8.41899743 354.500113,10.1949426 C355.246825,11.9708878 355.620176,13.8736577 355.620176,15.9033093 C355.620176,17.9329609 355.246825,19.8357308 354.500113,21.611676 C353.7534,23.3876212 352.733352,24.9365426 351.439939,26.2584868 C350.146526,27.5804309 348.626455,28.6219471 346.87968,29.3830664 C345.132906,30.1441858 343.259485,30.5247398 341.259361,30.5247398 C339.285906,30.5247398 337.439153,30.1441858 335.719047,29.3830664 C333.998941,28.6219471 332.498871,27.5804309 331.218792,26.2584868 C329.938713,24.9365426 328.925332,23.3876212 328.178619,21.611676 C327.431906,19.8357308 327.058556,17.9329609 327.058556,15.9033093 Z M329.978721,15.9033093 C329.978721,17.5857837 330.265401,19.1480579 330.83877,20.5901788 C331.412139,22.0322925 332.205509,23.2874602 333.218905,24.3556979 C334.232301,25.4239356 335.42569,26.2651601 336.799108,26.8793968 C338.172526,27.4936335 339.659263,27.8007472 341.259361,27.8007472 C342.886128,27.8007472 344.392866,27.4936335 345.779618,26.8793968 C347.16637,26.2651601 348.373093,25.4239356 349.399823,24.3556979 C350.426553,23.2874602 351.233258,22.0322925 351.81996,20.5901788 C352.406663,19.1480579 352.70001,17.5857837 352.70001,15.9033093 C352.70001,14.2208349 352.406663,12.6585607 351.81996,11.2164398 C351.233258,9.77431891 350.426553,8.51915843 349.399823,7.45092073 C348.373093,6.38268302 347.16637,5.54145845 345.779618,4.92722177 C344.392866,4.31298509 342.886128,4.00587136 341.259361,4.00587136 C339.659263,4.00587136 338.172526,4.31298509 336.799108,4.92722177 C335.42569,5.54145845 334.232301,6.38268302 333.218905,7.45092073 C332.205509,8.51915843 331.412139,9.77431891 330.83877,11.2164398 C330.265401,12.6585607 329.978721,14.2208349 329.978721,15.9033093 Z M336.379084,9.61409126 C336.379084,8.73279516 336.819105,8.29215371 337.699159,8.29215371 L342.219416,8.29215371 C343.659505,8.29215371 344.806225,8.70608962 345.659611,9.53397384 C346.512997,10.3618581 346.939684,11.4834908 346.939684,12.8989058 C346.939684,13.4864365 346.853013,14.0071946 346.679669,14.4611956 C346.506325,14.9151966 346.286315,15.3091034 346.019631,15.6429277 C345.752948,15.9767519 345.459601,16.2504837 345.139581,16.4641313 C344.819562,16.6777788 344.499547,16.8246593 344.179527,16.9047771 L344.179527,16.9848946 C344.206195,17.0116005 344.246197,17.0650116 344.299534,17.1451294 C344.35287,17.1985413 344.406206,17.2853343 344.459543,17.4055111 C344.51288,17.5256878 344.592883,17.6658919 344.699557,17.8261275 L346.779675,21.8720576 C347.019689,22.3260586 347.073025,22.6932598 346.939684,22.9736722 C346.806342,23.2540846 346.512995,23.3942887 346.059634,23.3942887 L345.579606,23.3942887 C344.832894,23.3942887 344.312869,23.0738222 344.019518,22.4328796 L341.699386,17.5457166 L339.219246,17.5457166 L339.219246,22.1124099 C339.219246,22.9670001 338.805893,23.3942887 337.979175,23.3942887 L337.619155,23.3942887 C336.792437,23.3942887 336.379084,22.9670001 336.379084,22.1124099 L336.379084,9.61409126 Z M341.619382,15.4626634 C342.392763,15.4626634 342.992791,15.2356663 343.419484,14.7816653 C343.846177,14.3276643 344.05952,13.7000841 344.05952,12.8989058 C344.05952,12.1244334 343.846177,11.5235587 343.419484,11.0962637 C342.992791,10.6689686 342.406097,10.4553242 341.659384,10.4553242 L339.219246,10.4553242 L339.219246,15.4626634 L341.619382,15.4626634 Z M225.01569,25.0407019 C229.537969,25.0407019 233.372982,25.6178754 236.520843,26.7722398 C239.668704,27.9266041 242.129319,28.9921553 243.902761,29.9689251 C245.410188,30.7681004 246.296896,31.8336516 246.562912,33.1656105 C246.828929,34.4975693 246.607252,35.9183042 245.897875,37.4278576 L244.567799,39.8253716 C243.76975,41.4237223 242.750036,42.3560795 241.508626,42.6224713 C240.267216,42.888863 238.804147,42.6668732 237.119377,41.9564952 C235.61195,41.2461171 233.794199,40.5135507 231.666067,39.758774 C229.537936,39.0039973 227.055153,38.6266146 224.217645,38.6266146 C221.291464,38.6266146 219.030358,39.2037881 217.43426,40.3581525 C215.838161,41.5125168 215.040124,43.1552415 215.040124,45.2863757 C215.040124,47.1511182 215.860329,48.6606489 217.500764,49.8150133 C219.141198,50.9693777 221.224962,51.9905308 223.752118,52.8785034 C226.279274,53.766476 228.983734,54.7210322 231.865579,55.7422007 C234.747423,56.7633692 237.451883,58.0731091 239.979039,59.6714598 C242.506195,61.2698104 244.589959,63.3121168 246.230394,65.79844 C247.870828,68.2847633 248.691033,71.4370187 248.691033,75.2553008 C248.691033,78.2744076 248.092505,81.0492804 246.895431,83.5800022 C245.698357,86.1107241 243.969277,88.3084233 241.708137,90.1731658 C239.446997,92.0379082 236.72037,93.503041 233.528173,94.5686081 C230.335976,95.6341752 226.789143,96.1669508 222.887569,96.1669508 C217.389896,96.1669508 212.756847,95.3677874 208.988281,93.7694368 C205.219715,92.1710861 202.315746,90.6615554 200.276286,89.2407992 C198.76886,88.3528266 197.926487,87.2428775 197.749143,85.9109186 C197.571799,84.5789598 197.970817,83.1582249 198.946211,81.6486715 L200.542301,79.2511575 C201.517695,77.8304014 202.603912,77.031238 203.800986,76.8536435 C204.99806,76.676049 206.438961,77.0312327 208.123732,77.9192053 C209.71983,78.8071779 211.781426,79.8061321 214.308582,80.9160978 C216.835738,82.0260635 219.828378,82.5810381 223.286592,82.5810381 C226.212772,82.5810381 228.518214,81.9594666 230.202984,80.716305 C231.887755,79.4731433 232.730128,77.7860207 232.730128,75.6548865 C232.730128,73.7901441 231.909923,72.3028123 230.269488,71.1928465 C228.629053,70.0828808 226.545289,69.0617276 224.018133,68.1293564 C221.490977,67.1969852 218.786518,66.198031 215.904673,65.1324639 C213.022828,64.0668968 210.318369,62.7349579 207.791213,61.1366072 C205.264057,59.5382566 203.180293,57.4959502 201.539858,55.009627 C199.899423,52.5233037 199.079218,49.3266503 199.079218,45.4195709 C199.079218,42.1340724 199.766417,39.2038068 201.140835,36.6286862 C202.515254,34.0535657 204.377341,31.9224635 206.727152,30.2353156 C209.076964,28.5481676 211.825759,27.2606267 214.97362,26.3726541 C218.121481,25.4846815 221.468804,25.0407019 225.01569,25.0407019 Z M27.307473,25.0407019 C31.8297521,25.0407019 35.6647647,25.6178754 38.8126257,26.7722398 C41.9604867,27.9266041 44.4211017,28.9921553 46.1945445,29.9689251 C47.7019709,30.7681004 48.588679,31.8336516 48.8546954,33.1656105 C49.1207119,34.4975693 48.8990348,35.9183042 48.1896577,37.4278576 L46.8595822,39.8253716 C46.061533,41.4237223 45.0418186,42.3560795 43.8004087,42.6224713 C42.5589987,42.888863 41.0959303,42.6668732 39.4111597,41.9564952 C37.9037333,41.2461171 36.0859816,40.5135507 33.9578503,39.758774 C31.8297189,39.0039973 29.3469362,38.6266146 26.5094277,38.6266146 C23.583247,38.6266146 21.3221414,39.2037881 19.7260428,40.3581525 C18.1299443,41.5125168 17.331907,43.1552415 17.331907,45.2863757 C17.331907,47.1511182 18.152112,48.6606489 19.7925466,49.8150133 C21.4329812,50.9693777 23.5167452,51.9905308 26.0439013,52.8785034 C28.5710573,53.766476 31.275517,54.7210322 34.1573616,55.7422007 C37.0392062,56.7633692 39.7436659,58.0731091 42.2708219,59.6714598 C44.7979779,61.2698104 46.881742,63.3121168 48.5221766,65.79844 C50.1626112,68.2847633 50.9828162,71.4370187 50.9828162,75.2553008 C50.9828162,78.2744076 50.3842882,81.0492804 49.1872143,83.5800022 C47.9901404,86.1107241 46.2610596,88.3084233 43.99992,90.1731658 C41.7387804,92.0379082 39.012153,93.503041 35.8199559,94.5686081 C32.6277588,95.6341752 29.0809264,96.1669508 25.1793522,96.1669508 C19.6816795,96.1669508 15.0486296,95.3677874 11.2800636,93.7694368 C7.51149765,92.1710861 4.6075286,90.6615554 2.56806936,89.2407992 C1.06064297,88.3528266 0.218270266,87.2428775 0.0409259849,85.9109186 C-0.136418297,84.5789598 0.262600352,83.1582249 1.2379939,81.6486715 L2.83408445,79.2511575 C3.809478,77.8304014 4.89569544,77.031238 6.09276934,76.8536435 C7.28984324,76.676049 8.73074391,77.0312327 10.4155146,77.9192053 C12.0116131,78.8071779 14.0732095,79.8061321 16.6003655,80.9160978 C19.1275215,82.0260635 22.1201614,82.5810381 25.5783749,82.5810381 C28.5045555,82.5810381 30.8099966,81.9594666 32.4947673,80.716305 C34.1795379,79.4731433 35.0219106,77.7860207 35.0219106,75.6548865 C35.0219106,73.7901441 34.2017056,72.3028123 32.561271,71.1928465 C30.9208364,70.0828808 28.8370724,69.0617276 26.3099164,68.1293564 C23.7827603,67.1969852 21.0783006,66.198031 18.196456,65.1324639 C15.3146115,64.0668968 12.6101517,62.7349579 10.0829957,61.1366072 C7.55583971,59.5382566 5.47207566,57.4959502 3.83164105,55.009627 C2.19120645,52.5233037 1.37100145,49.3266503 1.37100145,45.4195709 C1.37100145,42.1340724 2.05820023,39.2038068 3.43261841,36.6286862 C4.80703659,34.0535657 6.66912362,31.9224635 9.01893535,30.2353156 C11.3687471,28.5481676 14.1175422,27.2606267 17.2654032,26.3726541 C20.4132642,25.4846815 23.7605873,25.0407019 27.307473,25.0407019 Z M269.832233,0 C273.556463,0 275.41855,1.86471447 275.41855,5.59419935 L275.41855,33.0324152 C275.41855,33.9203878 275.396382,34.6973522 275.352046,35.3633316 C275.30771,36.0293111 275.241207,36.6286836 275.152534,37.1614671 C275.063862,37.7830479 275.019527,38.3158235 275.019527,38.7598098 L275.285542,38.7598098 C276.083591,37.1614591 277.214144,35.5409335 278.677234,33.8981842 C280.140325,32.2554349 281.869406,30.7681031 283.864529,29.4361442 C285.859652,28.1041853 288.120758,27.0386342 290.647914,26.2394589 C293.17507,25.4402835 295.901697,25.0407019 298.827878,25.0407019 C306.36501,25.0407019 312.195115,27.0830082 316.31837,31.1676821 C320.441625,35.252356 322.503221,41.8232546 322.503221,50.8805751 L322.503221,88.9744088 C322.503221,92.7038936 320.641134,94.5686081 316.916904,94.5686081 L311.197579,94.5686081 C307.47335,94.5686081 305.611263,92.7038936 305.611263,88.9744088 L305.611263,54.3436509 C305.611263,50.1701797 304.901896,46.8181334 303.483142,44.2874115 C302.064388,41.7566897 299.226922,40.4913477 294.970659,40.4913477 C292.044478,40.4913477 289.362186,41.0685212 286.923702,42.2228856 C284.485218,43.37725 282.423622,44.9533777 280.738851,46.951316 C279.054081,48.9492543 277.746186,51.3245454 276.815129,54.0772604 C275.884071,56.8299754 275.41855,59.804639 275.41855,63.0013403 L275.41855,88.9744088 C275.41855,92.7038936 273.556463,94.5686081 269.832233,94.5686081 L264.112908,94.5686081 C260.388678,94.5686081 258.526591,92.7038936 258.526591,88.9744088 L258.526591,5.59419935 C258.526591,1.86471447 260.388678,0 264.112908,0 L269.832233,0 Z M181.460219,26.6390445 C185.095777,26.6390445 186.913528,28.503759 186.913528,32.2332439 L186.913528,88.9744088 C186.913528,92.7038936 185.095777,94.5686081 181.460219,94.5686081 L175.607887,94.5686081 C171.972329,94.5686081 170.154577,92.7038936 170.154577,88.9744088 L170.154577,32.2332439 C170.154577,28.503759 171.972329,26.6390445 175.607887,26.6390445 L181.460219,26.6390445 Z M68.604816,26.6390445 C71.9743573,26.6390445 73.9694505,28.2817692 74.5901555,31.5672678 L85.4967743,71.2594441 C85.6741186,72.236214 85.8292925,73.1241733 85.9623007,73.9233486 C86.0953089,74.7225239 86.2504829,75.4772893 86.4278271,76.1876674 C86.6051714,76.9868427 86.7381776,77.7416081 86.8268498,78.4519862 L87.0928649,78.4519862 C87.181537,77.7416081 87.3145432,76.9868427 87.4918875,76.1876674 C87.6692318,75.4772893 87.8244057,74.7225239 87.9574139,73.9233486 C88.0904221,73.1241733 88.2899315,72.236214 88.5559479,71.2594441 L99.9945969,31.5672678 C100.615302,28.3705665 102.65473,26.7722398 106.112944,26.7722398 L111.167231,26.7722398 C114.4481,26.7722398 116.487529,28.3705665 117.285578,31.5672678 L128.591219,71.2594441 C128.857236,72.236214 129.056745,73.1241733 129.189753,73.9233486 C129.322761,74.7225239 129.477935,75.4772893 129.65528,76.1876674 C129.832624,76.9868427 129.96563,77.7416081 130.054302,78.4519862 L130.320317,78.4519862 C130.40899,77.7416081 130.541996,76.9868427 130.71934,76.1876674 C130.896684,75.4772893 131.051858,74.7225239 131.184866,73.9233486 C131.317875,73.1241733 131.517384,72.236214 131.7834,71.2594441 L142.557012,31.5672678 C143.355061,28.2817692 145.39449,26.6390445 148.675359,26.6390445 L154.793706,26.6390445 C156.833165,26.6390445 158.251898,27.2162181 159.049947,28.3705824 C159.847997,29.5249468 159.981003,31.0344776 159.44897,32.89922 L142.024981,89.9067753 C141.13826,93.0146794 139.054496,94.5686081 135.773627,94.5686081 L126.862121,94.5686081 C123.49258,94.5686081 121.408816,92.9702814 120.610767,89.7735801 L110.369185,55.8087983 C110.103169,54.9208257 109.881492,54.0328664 109.704148,53.1448939 C109.526803,52.2569213 109.349462,51.4577579 109.172118,50.7473798 C108.994773,49.9482045 108.861767,49.1934391 108.773095,48.4830611 L108.50708,48.4830611 C108.329736,49.1934391 108.152394,49.9482045 107.97505,50.7473798 C107.797705,51.4577579 107.620364,52.2569213 107.443019,53.1448939 C107.265675,54.0328664 107.043998,54.9208257 106.777982,55.8087983 L96.5364007,89.7735801 C95.7383514,92.9702814 93.6989227,94.5686081 90.4180535,94.5686081 L81.2405328,94.5686081 C78.0483358,94.5686081 76.0089071,93.0146794 75.1221857,89.9067753 L57.5651896,32.89922 C57.0331568,31.0344776 57.1883307,29.5249468 58.030716,28.3705824 C58.8731014,27.2162181 60.2696666,26.6390445 62.2204537,26.6390445 L68.604816,26.6390445 Z", id: "swish\\xAE" })),
            React.createElement("g", { id: "Symbol/Colour" },
                React.createElement("g", { id: "Right-Swirl", transform: "translate(50.005869, 20.581194)" },
                    React.createElement("path", { d: "M0,146.685268 C35.320882,163.577834 78.9117034,155.217748 105.246455,123.83961 C136.460269,86.64832 131.612113,31.2033405 94.4177327,-5.68434189e-14 L69.6915356,29.4617132 C98.7493932,53.8393444 102.537085,97.1556059 78.1513834,126.211403 C58.7070751,149.379356 26.6929327,157.114942 0,146.685268", id: "Base-Shape", fill: "url(#linearGradient-1)" }),
                    React.createElement("path", { d: "M1.13686838e-13,146.685268 C35.320882,163.577834 78.9117034,155.217748 105.246455,123.83961 C108.471633,119.9968 111.310642,115.958759 113.770006,111.77305 C117.928757,85.9298966 108.78311,58.6143532 87.2695571,40.5661971 C81.803598,35.9805815 75.8865639,32.2862985 69.6953132,29.4651473 C98.7497366,53.8432937 102.535883,97.1569795 78.1513834,126.211403 C58.7070751,149.379356 26.6929327,157.114942 1.13686838e-13,146.685268", id: "Light-Cast", fill: "url(#linearGradient-2)" })),
                React.createElement("g", { id: "Left-Swirl" },
                    React.createElement("path", { d: "M125.821122,8.56068559 C90.5004122,-8.33188026 46.9095908,0.0280338815 20.5748395,31.4061724 C-10.6389751,68.5976339 -5.790819,124.042613 31.4033898,155.245954 L56.1297586,125.784241 C27.0717293,101.406609 23.2842093,58.090348 47.6699108,29.0343792 C67.114219,5.86642608 99.1283615,-1.86916026 125.821122,8.56068559", id: "Base-shape", fill: "url(#linearGradient-3)" }),
                    React.createElement("path", { d: "M125.821122,8.56068559 C90.5004122,-8.33188026 46.9095908,0.0280338815 20.5748395,31.4061724 C17.3494893,35.2491539 14.5104805,39.2871949 12.0512883,43.4729041 C7.89236539,69.3160573 17.0381839,96.631429 38.5517371,114.679757 C44.0176961,119.265201 49.9347303,122.959655 56.1258093,125.780635 C27.0715576,101.40266 23.2852395,58.0889744 47.6699108,29.0343792 C67.114219,5.86642608 99.1283615,-1.86916026 125.821122,8.56068559", id: "Shadow", fill: "url(#linearGradient-4)" }))))));
};

var BankID = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 42 : _b;
    return (React.createElement("svg", { width: size, height: size * 0.97, viewBox: "0 0 42 41", fill: "none" },
        React.createElement("path", { d: "M13.1676 21.1079L14.9109 9.85042C14.2242 9.85042 13.0487 9.85042 13.0487 9.85042C12.1771 9.85042 11.0545 9.34979 10.7243 8.42971C10.6187 8.1185 10.3677 7.04958 11.8073 6.00772C12.3224 5.64239 12.6525 5.23647 12.7186 4.92527C12.7846 4.60053 12.7054 4.31639 12.4808 4.0999C12.1639 3.78869 11.5432 3.61279 10.7507 3.61279C9.41683 3.61279 8.47913 4.39757 8.38669 4.96586C8.32065 5.38531 8.63762 5.72358 8.91496 5.94007C9.747 6.57601 9.94511 7.49609 9.43004 8.36205C8.90176 9.25508 7.75275 9.83689 6.5245 9.85042C6.5245 9.85042 5.30946 9.85042 4.6227 9.85042C4.46421 10.9464 1.87564 27.7515 1.67754 29.0775H11.9922C12.0846 28.4821 12.5601 25.3024 13.2072 21.1079H13.1676Z", fill: '#459BBE' }),
        React.createElement("path", { d: "M26.9816 0H16.482L15.0821 9.10613H16.865C17.8424 9.10613 18.7668 8.64609 19.163 7.98309C19.2951 7.7666 19.3479 7.57717 19.3479 7.40127C19.3479 7.02241 19.097 6.73827 18.8461 6.54884C18.1593 6.02114 18.014 5.46638 18.014 5.074C18.014 4.99281 18.014 4.92516 18.0272 4.85751C18.1725 3.89683 19.4404 2.85497 21.1177 2.85497C22.1214 2.85497 22.8874 3.09852 23.3497 3.54503C23.7591 3.93742 23.9176 4.49218 23.7987 5.074C23.6534 5.76406 22.9799 6.33235 22.5969 6.61649C21.5799 7.34715 21.712 7.98309 21.778 8.17252C21.9893 8.7408 22.795 9.10613 23.4157 9.10613H26.1231C26.1231 9.10613 26.1231 9.10613 26.1231 9.11966C29.8211 9.14672 31.8021 10.8922 31.1814 14.9514C30.6003 18.7264 27.774 20.3501 24.4062 20.3772L23.0723 29.0909H25.0402C33.3473 29.0909 40.1357 23.6245 41.4696 14.992C43.1205 4.27569 36.4906 0 26.9816 0Z", fill: '#00A5C3' }),
        React.createElement("path", { d: "M26.9816 0H16.482L15.0821 9.10613H16.865C17.8424 9.10613 18.7668 8.64609 19.163 7.98309C19.2951 7.7666 19.3479 7.57717 19.3479 7.40127C19.3479 7.02241 19.097 6.73827 18.8461 6.54884C18.1593 6.02114 18.014 5.46638 18.014 5.074C18.014 4.99281 18.014 4.92516 18.0272 4.85751C18.1725 3.89683 19.4404 2.85497 21.1177 2.85497C22.1214 2.85497 22.8874 3.09852 23.3497 3.54503C23.7591 3.93742 23.9176 4.49218 23.7987 5.074C23.6534 5.76406 22.9799 6.33235 22.5969 6.61649C21.5799 7.34715 21.712 7.98309 21.778 8.17252C21.9893 8.7408 22.795 9.10613 23.4157 9.10613H26.1231C26.1231 9.10613 26.1231 9.10613 26.1231 9.11966C29.8211 9.14672 31.8021 10.8922 31.1814 14.9514C30.6003 18.7264 27.774 20.3501 24.4062 20.3772L23.0723 29.0909H25.0402C33.3473 29.0909 40.1357 23.6245 41.4696 14.992C43.1205 4.27569 36.4906 0 26.9816 0Z", fill: '#235971' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.12259 32.9604H5.33562C7.13177 32.9604 7.5676 33.8941 7.43553 34.7465C7.32987 35.4366 6.86763 35.9507 6.07521 36.289C7.07894 36.6814 7.47515 37.2903 7.32987 38.2509C7.14497 39.4552 6.12804 40.3482 4.79413 40.3482H0L1.12259 32.9604ZM3.90873 36.0186C4.72757 36.0186 5.11057 35.5721 5.18981 35.0444C5.26905 34.4761 5.01812 34.0837 4.19929 34.0837H3.4729L3.18235 36.0186H3.90873ZM4.91337 38.1432C4.79451 38.8603 4.30585 39.2121 3.46061 39.2121V39.2256H2.6946L3.01157 37.1555H3.84361C4.66244 37.1555 5.00582 37.5208 4.91337 38.1432Z", fill: '#235971' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.3448 39.8751C11.6089 40.3622 12.1372 40.484 13.2334 40.4028L13.8673 38.8874C13.2466 38.8739 13.2202 38.698 13.3126 38.1297L13.5635 36.506C13.7749 35.0717 12.6391 34.5305 11.358 34.5305C10.3543 34.5305 9.48259 34.8417 8.58452 35.5047L8.33358 37.1825C9.37694 36.4519 9.98446 36.2083 10.7108 36.2083C11.3316 36.2083 11.5297 36.3977 11.4768 36.9119C11.1795 37.1191 10.6732 37.2494 10.1437 37.3857C9.49746 37.5521 8.81673 37.7273 8.43924 38.062C8.12227 38.3462 7.92417 38.6844 7.87134 39.0362C7.75248 39.7669 8.18831 40.4299 9.42976 40.4299C10.1165 40.4299 10.7637 40.2405 11.3448 39.8751ZM10.6145 38.1441C10.873 38.0667 11.1317 37.9892 11.3313 37.8591L11.2124 38.671C11.1728 38.928 11.1596 39.0634 11.186 39.1987C10.8426 39.4422 10.42 39.591 10.0766 39.591C9.72003 39.591 9.49551 39.3204 9.54834 38.9551C9.62639 38.4398 10.1201 38.292 10.6145 38.1441Z", fill: '#235971' }),
        React.createElement("path", { d: "M15.2812 34.6252H17.4736L17.3547 35.3694C18.0547 34.7605 18.583 34.5305 19.2697 34.5305C20.498 34.5305 21.0659 35.3018 20.8678 36.5601L20.2999 40.3352H18.1075L18.583 37.2096C18.6754 36.6413 18.5037 36.3707 18.0811 36.3707C17.7377 36.3707 17.4207 36.5601 17.117 36.9796L16.6151 40.3216H14.4228L15.2812 34.6252Z", fill: '#235971' }),
        React.createElement("path", { d: "M22.5711 32.9604H24.7635L24.2088 36.5867L26.3087 34.6247H29.0162L26.3219 37.0602L28.4879 40.3347H25.7276L24.0635 37.6962H24.0371L23.6409 40.3347H21.4486L22.5711 32.9604Z", fill: '#235971' }),
        React.createElement("path", { d: "M30.3367 32.9604H32.8592L31.7498 40.3347H29.2273L30.3367 32.9604Z", fill: '#459BBE' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.6923 32.9604H34.0868L32.9642 40.3347H37.0319C39.4752 40.3347 40.7695 38.4268 41.0204 36.749C41.2846 35.0306 40.4789 32.9604 37.6923 32.9604ZM38.5244 36.6414C38.3263 37.9539 37.6527 38.5763 36.4245 38.5763H35.7641L36.3453 34.7065H37.0188C38.3791 34.7065 38.6697 35.6672 38.5244 36.6414Z", fill: '#459BBE' })));
};

var Icons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BankIDLogo: BankID,
    Close: Close,
    SwishLogo: Swish,
    bankid: BankID$1,
    swish: Swish$1
});

var MainButton = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, logo = _a.logo, props = __rest(_a, ["children", "variant", "color", "logo"]);
    var theme = useThemeContext();
    var Icon = logo && Icons[logo];
    return (React__default.createElement(Button$1, __assign({ fullWidth: false, variant: variant, color: color, startIcon: Icon != null && (React__default.createElement(Icon, { color: variant === 'contained'
                ? theme.color.general.white
                : theme.color.button.main.BG, size: 24 })) }, props), children));
};

var Stepper = function (props) { return (React__default.createElement(MuiStepper, __assign({}, props, { connector: React__default.createElement(StepConnector, null) }))); };

var Light = Theme.ColorScheme.Light;
var getButtonIconColor = function (_a) {
    var active = _a.active, completed = _a.completed;
    if (completed) {
        return Light.stepper.complete;
    }
    if (active) {
        return Light.stepper.active;
    }
    return Light.stepper.default;
};
var StepButtonIcon = function (_a) {
    var active = _a.active, completed = _a.completed;
    var stepColor = getButtonIconColor({ active: active, completed: completed });
    return (React__default.createElement("div", { style: __assign({ height: 12, width: 12, borderRadius: 100 }, (completed
            ? { border: "2px solid ".concat(stepColor), background: stepColor }
            : {
                border: "2px solid ".concat(stepColor),
            })) }));
};
var StepButton = function (props) { return (React__default.createElement(MuiStepButton, __assign({}, props, { icon: React__default.createElement(StepButtonIcon, { active: props.active, completed: props.completed }) }))); };

var BaseOverlay = function (_a) {
    var children = _a.children;
    var theme = useThemeContext();
    var style = themeStyle$2({ theme: theme });
    return (
    // @ts-ignore
    React__default.createElement(Modal, { open: true },
        React__default.createElement("div", { style: style.containerWrapper },
            React__default.createElement("div", { style: style.container }, children))));
};
var themeStyle$2 = function (_a) {
    var theme = _a.theme;
    return ({
        modal: {
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            opacity: 1,
            zIndex: 99,
        },
        containerWrapper: {
            background: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            height: '100%',
            width: '100%',
            overflow: 'scroll',
            padding: '10px 0px',
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            background: theme.color.general.white,
            borderRadius: 6,
            margin: 'auto',
            padding: theme.deprecated.layoutSpace.medium,
            position: 'relative',
            width: '90%',
            maxWidth: '570px',
        },
    });
};

var Box = function (props) {
    var theme = useThemeContext();
    var styles = React__default.useMemo(function () { return (__assign(__assign({}, themeStyle$1(__assign({ theme: theme }, props))), props.style)); }, []);
    return (React__default.createElement("div", { style: styles, props: props }, props.children));
};
var themeStyle$1 = function (_a) {
    var theme = _a.theme, align = _a.align, justify = _a.justify, hasPadding = _a.hasPadding, direction = _a.direction, color = _a.color, flex = _a.flex;
    return ({
        display: 'flex',
        flexDirection: direction,
        paddingHorizontal: hasPadding ? theme.deprecated.layoutSpace.medium : 0,
        justifyContent: justify,
        alignItems: align,
        backgroundColor: color || 'transparent',
        flex: flex ? 1 : 0,
    });
};

var rotate = keyframes(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"], ["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Wrapper = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  width: 36px;\n  height: 36px;\n  animation: ", " 0.75s linear infinite;\n"], ["\n  width: 36px;\n  height: 36px;\n  animation: ", " 0.75s linear infinite;\n"])), rotate);
var Loader = function () { return (React__default.createElement(Wrapper, null,
    React__default.createElement("svg", { height: "100%", viewBox: "0 0 32 32", width: "100%" },
        React__default.createElement("circle", { cx: "16", cy: "16", fill: "none", r: "14", strokeWidth: "4", style: { stroke: 'rgb(51, 44, 107)', opacity: 0.2 } }),
        React__default.createElement("circle", { cx: "16", cy: "16", fill: "none", r: "14", strokeWidth: "4", style: {
                stroke: 'rgb(51, 44, 107)',
                strokeDasharray: 80,
                strokeDashoffset: 60,
            } })))); };
var templateObject_1$2, templateObject_2$1;

// @ts-ignore
var Overlay = function (_a) {
    var hasAnimation = _a.hasAnimation, contentContainerStyle = _a.contentContainerStyle, iconName = _a.iconName, iconStyle = _a.iconStyle, iconColor = _a.iconColor, logo = _a.logo, title = _a.title, body = _a.body, actionComponent = _a.actionComponent, isLoading = _a.isLoading, onDismiss = _a.onDismiss, hideDismiss = _a.hideDismiss, dismissText = _a.dismissText, dismissTextStyle = _a.dismissTextStyle;
    var theme = useThemeContext();
    var style = themeStyle({ theme: theme });
    var iconNameLower = iconName === null || iconName === void 0 ? void 0 : iconName.toLowerCase();
    var Icon = Icons[
    // @ts-ignore
    logo === 'BankID'
        ? 'BankIDLogo'
        : logo === 'Swish'
            ? 'SwishLogo'
            : iconNameLower];
    return (React__default.createElement(BaseOverlay, { contentContainerStyle: __assign(__assign({}, style.styledContentContainer), contentContainerStyle), hasAnimation: hasAnimation },
        hideDismiss !== 'top' && hideDismiss !== 'both' && (React__default.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'flex-end',
            }, onClick: onDismiss },
            React__default.createElement(Close, { color: theme.color.text.main, size: theme.deprecated.iconInnerSize.small }))),
        React__default.createElement(Box, { style: style.mainContent },
            React__default.createElement(Box, { style: style.mainTextContent },
                Icon != null && (React__default.createElement("div", { style: __assign(__assign({}, style.mainIcon), iconStyle) },
                    React__default.createElement(Icon, { size: logo === 'Swish' ? 163 : 70, color: iconColor !== null && iconColor !== void 0 ? iconColor : theme.color.text.main }))),
                title != null && React__default.createElement("p", { style: style.titleText }, title),
                body != null && React__default.createElement("p", { style: style.bodyText }, body),
                isLoading && React__default.createElement(Loader, null),
                actionComponent),
            hideDismiss !== 'bottom' && hideDismiss !== 'both' && (React__default.createElement("div", { onClick: onDismiss },
                React__default.createElement("p", { style: __assign(__assign({}, style.dismissText), dismissTextStyle) }, dismissText))))));
};
var themeStyle = function (_a) {
    var theme = _a.theme;
    return ({
        container: {
            display: 'flex',
            position: 'absolute',
            elevation: 4,
            zIndex: 50,
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
        contentContainer: {
            display: 'flex',
            backgroundColor: theme.color.background.surface,
            width: '92%',
            borderRadius: 16,
        },
        styledContentContainer: {
            alignItems: 'center',
            paddingVertical: theme.deprecated.layoutSpace.xlarge,
            paddingHorizontal: theme.deprecated.layoutSpace.medium,
        },
        closeIcon: {
            position: 'absolute',
            top: 6,
            right: 6,
            color: theme.color.text.main,
        },
        mainIcon: {
            minHeight: 70,
            justifyContent: 'center',
        },
        mainContent: {
            display: 'flex',
            flexDirection: 'column',
        },
        mainTextContent: {
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            flex: 1,
        },
        titleText: {
            fontFamily: theme.fontFamily.bold,
            fontSize: theme.deprecated.fontSize.medium,
            color: theme.color.text.main,
            marginTop: 18,
            marginBottom: 10,
            textAlign: 'center',
        },
        bodyText: {
            paddingBottom: 18,
            fontFamily: theme.fontFamily.regular,
            fontSize: theme.deprecated.fontSize.xsmall,
            lineHeight: "".concat(theme.deprecated.lineHeight.medium, "px"),
            color: theme.color.text.sub2,
            textAlign: 'center',
            paddingHorizontal: theme.deprecated.layoutSpace.xlarge,
        },
        activityIndicator: {
            paddingBottom: 46,
        },
        dismissText: {
            textAlign: 'center',
            fontFamily: theme.fontFamily.bold,
            fontSize: theme.deprecated.fontSize.xsmall,
            color: theme.color.clickable.text.orange,
        },
        iconStyle: {
            borderRadius: 50,
            borderWidth: 3,
            fontSize: 24,
            width: 100,
            height: 100,
        },
    });
};

var Radio = styled(MUIRadio)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  &:hover {\n    background: none;\n  }\n  &.Mui-checked {\n    &:hover {\n      background: none;\n    }\n    color: ", ";\n  }\n"], ["\n  &:hover {\n    background: none;\n  }\n  &.Mui-checked {\n    &:hover {\n      background: none;\n    }\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.form.checkbox.checkedColor;
});
var templateObject_1$1;

var disabledStyling = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    opacity: 0.6;\n  }\n"], ["\n  && {\n    opacity: 0.6;\n  }\n"])));
var StyledButton = styled(MainButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n  ", "\n"], ["\n  margin: ", ";\n  ", "\n"])), function (_a) {
    var $noMargin = _a.$noMargin;
    return ($noMargin ? 0 : '8px 0px 8px');
}, function (_a) {
    var $isValid = _a.$isValid;
    return typeof $isValid !== 'undefined' && !$isValid && disabledStyling;
});
var StyledCircularProgress = styled(CircularProgress)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: '#fff';\n  height: 24px !important;\n  width: 24px !important;\n"], ["\n  color: '#fff';\n  height: 24px !important;\n  width: 24px !important;\n"])));
var Button = function (_a) {
    var noMargin = _a.noMargin, isValid = _a.isValid, loading = _a.loading, children = _a.children, props = __rest(_a, ["noMargin", "isValid", "loading", "children"]);
    return (React__default.createElement(StyledButton, __assign({ "$noMargin": noMargin, "$isValid": isValid, disabled: loading }, props), loading ? React__default.createElement(StyledCircularProgress, null) : children));
};
var templateObject_1, templateObject_2, templateObject_3;

var _a;
var DRAWER_WIDTH = 130;
var Drawer = function (_a) {
    var listOptions = _a.listOptions;
    return (React__default.createElement(StyledDrawer, { variant: "permanent" },
        React__default.createElement(Toolbar, null),
        React__default.createElement(StyledList, null, listOptions.map(function (_a) {
            var title = _a.title, icon = _a.icon, onClick = _a.onClick, selected = _a.selected;
            return (React__default.createElement(StyledListButton, { key: title, disableRipple: true, selected: selected, onClick: onClick },
                icon,
                React__default.createElement(ListButtonTitle, null, title)));
        }))));
};
var StyledListButton = styled$1(ListItemButton)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '16px',
});
var ListButtonTitle = styled$1('span')({ fontSize: '13px' });
var StyledDrawer = styled$1(Drawer$1)((_a = {
        width: DRAWER_WIDTH,
        flexShrink: 0
    },
    _a["& .MuiDrawer-paper"] = {
        width: DRAWER_WIDTH,
        boxSizing: 'border-box',
    },
    _a));
var StyledList = styled$1(List)({
    display: 'flex',
    flexDirection: 'column',
    pt: 0,
});

var TextField = function (_a) {
    var selectOptions = _a.selectOptions, rest = __rest(_a, ["selectOptions"]);
    return (React__default.createElement(MuiTextField, __assign({}, rest, { variant: "filled", fullWidth: true }), selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.map(function (_a) {
        var value = _a.value, text = _a.text;
        return (React__default.createElement(MenuItem, { key: value, value: value }, text));
    })));
};

export { BaseOverlay, Button, Checkbox, Drawer, Loader, muiTheme as MUITheme, MainButton, Overlay, pay2Theme as Pay2Theme, Radio, StepButton, Stepper, TextField, ThemeProvider, theme2022, useThemeContext };
//# sourceMappingURL=index.js.map
